<template>
  <transition name="FadeIn">
    <div
      class="Form"
      v-if="forms.volunteersForm.opened"
      @click.self="managePopupState({ popup: 'volunteersForm', _state: false })"
    >
      <div class="Form__inner">
        <div
          class="Form__close"
          @click="managePopupState({ popup: 'volunteersForm', _state: false })"
        >
          <span>&times;</span>
        </div>
        <div class="Form__caption">
          <h4>{{ $t("FOR_VOLUNTEERS_TITLE") }}</h4>
        </div>
        <form
          class="Form__data"
          ref="volunteersForm"
          enctype="multipart/form-data"
          novalidate
        >
          <div
            class="Form__input"
            :class="{
              _error: $v.name.$dirty && !$v.name.required,
              _success: $v.name.$dirty && $v.name.required
            }"
          >
            <input
              v-model.trim="name"
              type="text"
              :placeholder="$t('NAME')"
              name="VolRequests[name]"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.name.$dirty && !$v.name.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.phone.$dirty && !$v.phone.required,
              _success: $v.phone.$dirty && $v.phone.required
            }"
          >
            <input
              v-model.trim="phone"
              type="tel"
              :placeholder="$t('PHONE')"
              name="VolRequests[phone]"
              v-mask="['+# (###) ### - ## - ##']"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.phone.$dirty && !$v.phone.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.about.$dirty && !$v.about.required,
              _success: $v.about.$dirty && $v.about.required
            }"
          >
            <textarea
              v-model.trim="about"
              type="text"
              :placeholder="$t('DESCRIBE_YOURSELF')"
              name="VolRequests[text]"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.about.$dirty && !$v.about.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.files.$dirty && !$v.files.required,
              _success: $v.files.$dirty && $v.files.required
            }"
          >
            <input
              type="file"
              id="file"
              name="VolRequests[files]"
              required
              @change="getFiles($event)"
            />
            <label for="file" class="button button_secondary Form__file-upload">
              <span>{{ $t("UPLOAD_FILE") }}</span>
            </label>
            <div
              class="Form__input_error"
              v-if="$v.files.$dirty && !$v.files.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
            <ul class="Form__files">
              <li
                class="Form__file"
                v-for="({ name, lastModified }, index) of files"
                :key="lastModified"
              >
                <span>{{ name }}</span>
                <div class="Form__file_delete" @click="deleteFile(index)">
                  <span>&times;</span>
                </div>
              </li>
            </ul>
          </div>

          <div class="Form__messages">
            <div
              :class="{ success: response.success, error: response.error }"
              v-if="response.text"
            >
              <span>{{ response.text }}</span>
            </div>
          </div>

          <div class="Form__submit" @click.prevent="submitHundler()">
            <button
              :disabled="disabled"
              type="submit"
              class="Form__button button button_primary"
            >
              <span>{{ $t("SEND") }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";

export default {
  name: "VolunteersForm",
  data: () => ({
    name: "",
    phone: "",
    about: "",
    files: null,
    disabled: false,
    response: {
      text: null,
      error: null,
      success: null
    }
  }),
  computed: {
    ...mapGetters(["forms"])
  },
  methods: {
    ...mapMutations(["managePopupState"]),
    ...mapActions(["sendRequest"]),
    async submitHundler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.disabled = true;

      const formData = new FormData(this.$refs.volunteersForm);
      await this.sendRequest({
        API: `${process.env.VUE_APP_KZ}/common/send-volunteer-request`,
        body: formData
      })
        .then(
          response => (
            response.status == 200
              ? ((this.response.text = this.$t("VUE.FORM_RESPONSE.SUCCESS")),
                (this.response.success = true))
              : ((this.response.text = this.$t("VUE.FORM_RESPONSE.REJECT")),
                (this.response.error = true)),
            setTimeout(() => {
              this.response.text = null;
              this.managePopupState({ popup: "volunteersForm", _state: false });
            }, 3000)
          )
        )
        .catch(
          () => (
            ((this.response.text = this.$t("VUE.FORM_RESPONSE.ERROR")),
            (this.response.error = true)),
            setTimeout(() => {
              this.response.text = null;
              this.managePopupState({ popup: "volunteersForm", _state: false });
            }, 3000)
          )
        )
        .finally(() => {
          this.name = this.phone = this.text = this.files = null;
          this.disabled = false;
        });
    },
    getFiles(e) {
      this.files = [...e.target.files];
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    }
  },
  validations: {
    name: { required },
    phone: { required, minLength: minLength(11) },
    about: { required },
    files: { required }
  },
  directives: { mask }
};
</script>

<style lang="scss">
.FadeIn-enter-active,
.FadeIn-leave-active {
  transition: all 0.2s ease;
}

.FadeIn-enter,
.FadeIn-leave-to {
  opacity: 0;
}
</style>
